/* import __COLOCATED_TEMPLATE__ from './semifinal-u16-startlist-interface.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default class HeatStartlistComponent extends Component
{
	@service store;
	@service csv;
	@service sprintTools;
	
	@tracked sourceEvent;
	@tracked sourceClassGroup;
	
	@tracked bibOffset = 0;
	@tracked resultsOffset = 30;
	@tracked selectedClasses = ['U16'];

	get isU14Selected() { return this.selectedClasses.includes('U14'); }
	get isU16Selected() { return this.selectedClasses.includes('U16'); }
	get isU18Selected() { return this.selectedClasses.includes('U18'); }
	get isU20Selected() { return this.selectedClasses.includes('U20'); }

	@tracked S1ClassGroup;
	@tracked S2ClassGroup;
	@tracked S3ClassGroup;
	
	@tracked top30Results;
	@tracked nextResults;
	
	@tracked S1Assignments;
	@tracked S2Assignments;
	@tracked S3Assignments;
	
	@tracked startTimeS1;
	@tracked startTimeS2;
	@tracked startTimeS3;
	
	@action
	async sourceEventChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.sourceEvent = null;
			this.sourceClassGroup = null;
		}
		else
		{
			var event = await this.store.findRecord('Event', browserEvent.target.value);
			this.sourceEvent = event;
			this.sourceClassGroup = null;
		}
		
		this.updateResults();
	}
	
	@action
	async classGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.sourceClassGroup = null;
			this.updateResults();
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.sourceClassGroup = classGroup;
		}
		
		this.updateResults();
	}
	
	@action
	bibOffsetChanged(browserEvent)
	{
		browserEvent.preventDefault();
		this.updateHeatAssignments();
	}

	@action
	resultsOffsetChanged(browserEvent)
	{
		this.resultsOffset = parseInt(browserEvent.target.value) || 30;
		this.updateResults();
	}

	@action
	classFilterChanged(className, browserEvent)
	{
		if(browserEvent.target.checked)
		{
			this.selectedClasses = [...this.selectedClasses, className];
		}
		else
		{
			this.selectedClasses = this.selectedClasses.filter(c => c !== className);
		}
		this.updateResults();
	}

	@action
	tieSelectionChanged(result, browserEvent)
	{
		result.set('useResultForTie', browserEvent.target.checked);
		this.updateHeatAssignments();
	}
	
	@action
	async S1ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.S1ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.S1ClassGroup = classGroup;
			this.startTimeS1 = dayjs(classGroup.startTime).format("HH:mm:ss");
			this.updateHeatAssignments();
		}
	}
	
	@action
	async S2ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.S2ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.S2ClassGroup = classGroup;
			this.startTimeS2 = dayjs(classGroup.startTime).format("HH:mm:ss");
			this.updateHeatAssignments();
		}
	}
	
	@action
	async S3ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.S3ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.S3ClassGroup = classGroup;
			this.startTimeS3 = dayjs(classGroup.startTime).format("HH:mm:ss");
			this.updateHeatAssignments();
		}
	}
	
	@action
	exportHeatStartListCSV()
	{
		// Check if assignments exist before exporting
		if (!this.S1Assignments || !this.S2Assignments || !this.S3Assignments) {
			return;
		}

		var buildData = (assignments, classGroup, startTime) => {
			var data = [...this.sprintTools.getCSVHeaders()];
			for (const result of assignments) {
				data.push(this.sprintTools.buildCSVRow(result, classGroup, startTime, result.newBib));
			}
			return data;
		};

		this.csv.export(buildData(this.S1Assignments, this.S1ClassGroup, this.startTimeS1), {fileName:'S1quarterfinalsStartlist.csv',withSeparator:false});
		this.csv.export(buildData(this.S2Assignments, this.S2ClassGroup, this.startTimeS2), {fileName:'S2quarterfinalsStartlist.csv',withSeparator:false});
		this.csv.export(buildData(this.S3Assignments, this.S3ClassGroup, this.startTimeS3), {fileName:'S3quarterfinalsStartlist.csv',withSeparator:false});
	}
	
	@action
	async createClasses()
	{
		var destinationEvent = this.args.destinationEvent;
		var destinationClasses = await destinationEvent.get('classes');

		await this.sprintTools.createClassesForHeat(destinationEvent, destinationClasses, this.S1ClassGroup, this.S1Assignments);
		await this.sprintTools.createClassesForHeat(destinationEvent, destinationClasses, this.S2ClassGroup, this.S2Assignments);
		await this.sprintTools.createClassesForHeat(destinationEvent, destinationClasses, this.S3ClassGroup, this.S3Assignments);
	}
	
	@action
	async createEntries()
	{
		var destinationEvent = this.args.destinationEvent;
		var destinationEntries = await destinationEvent.get('entries');
		var destinationClasses = await destinationEvent.get('classes');

		await this.sprintTools.createEntriesForHeat(destinationEvent, destinationEntries, destinationClasses, this.S1ClassGroup, this.S1Assignments, this.startTimeS1);
		await this.sprintTools.createEntriesForHeat(destinationEvent, destinationEntries, destinationClasses, this.S2ClassGroup, this.S2Assignments, this.startTimeS2);
		await this.sprintTools.createEntriesForHeat(destinationEvent, destinationEntries, destinationClasses, this.S3ClassGroup, this.S3Assignments, this.startTimeS3);
	}
	
	updateHeatAssignments()
	{	
		
		var bibOffset = parseInt(this.bibOffset);
		
		//only assign heats if all class groups have valid selections
		if(	this.S1ClassGroup == null || 
			this.S2ClassGroup == null ||
			this.S3ClassGroup == null)
		{
			return;
		}
		
		//only assign heats if the top30Results is populated fully
		if(this.nextResults == null)// || this.top30Results.length != 30)
		{
			return;
		}
		
		var S1Assignments = [];
		var S2Assignments = [];
		var S3Assignments = [];
		
		//S1: 1,6,7,12,13,18
		if(this.nextResults.length > 0)
		{
			this.nextResults[0].set('newBib',1+bibOffset);
			this.nextResults[0].set('heatStartOrder',1);
			S1Assignments.push(this.nextResults[0]);
		}
		if(this.nextResults.length > 5)
		{
			this.nextResults[5].set('newBib',6+bibOffset);
			this.nextResults[5].set('heatStartOrder',2);
			S1Assignments.push(this.nextResults[5]);
		}
		if(this.nextResults.length > 6)
		{
			this.nextResults[6].set('newBib',7+bibOffset);
			this.nextResults[6].set('heatStartOrder',3);
			S1Assignments.push(this.nextResults[6]);
		}
		if(this.nextResults.length > 11)
		{
			this.nextResults[11].set('newBib',12+bibOffset);
			this.nextResults[11].set('heatStartOrder',4);
			S1Assignments.push(this.nextResults[11]);
		}
		if(this.nextResults.length > 12)
		{
			this.nextResults[12].set('newBib',13+bibOffset);
			this.nextResults[12].set('heatStartOrder',5);
			S1Assignments.push(this.nextResults[12]);
		}
		if(this.nextResults.length > 17)
		{
			this.nextResults[17].set('newBib',18+bibOffset);
			this.nextResults[17].set('heatStartOrder',6);
			S1Assignments.push(this.nextResults[17]);
		}
		
		//S2: 2,5,8,11,14,17
		if(this.nextResults.length > 1)
		{
			this.nextResults[1].set('newBib',2+bibOffset);
			this.nextResults[1].set('heatStartOrder',1);
			S2Assignments.push(this.nextResults[1]);
		}
		if(this.nextResults.length > 4)
		{
			this.nextResults[4].set('newBib',5+bibOffset);
			this.nextResults[4].set('heatStartOrder',2);
			S2Assignments.push(this.nextResults[4]);
		}
		if(this.nextResults.length > 7)
		{
			this.nextResults[7].set('newBib',8+bibOffset);
			this.nextResults[7].set('heatStartOrder',3);
			S2Assignments.push(this.nextResults[7]);
		}
		if(this.nextResults.length > 10)
		{
			this.nextResults[10].set('newBib',11+bibOffset);
			this.nextResults[10].set('heatStartOrder',4);
			S2Assignments.push(this.nextResults[10]);
		}
		if(this.nextResults.length > 13)
		{
			this.nextResults[13].set('newBib',14+bibOffset);
			this.nextResults[13].set('heatStartOrder',5);
			S2Assignments.push(this.nextResults[13]);
		}
		if(this.nextResults.length > 16)
		{
			this.nextResults[16].set('newBib',17+bibOffset);
			this.nextResults[16].set('heatStartOrder',6);
			S2Assignments.push(this.nextResults[16]);
		}
		
		//S3: 3,4,9,10,15,16
		if(this.nextResults.length > 2)
		{
			this.nextResults[2].set('newBib',3+bibOffset);
			this.nextResults[2].set('heatStartOrder',1);
			S3Assignments.push(this.nextResults[2]);
		}
		if(this.nextResults.length > 3)
		{
			this.nextResults[3].set('newBib',4+bibOffset);
			this.nextResults[3].set('heatStartOrder',2);
			S3Assignments.push(this.nextResults[3]);
		}
		if(this.nextResults.length > 8)
		{
			this.nextResults[8].set('newBib',9+bibOffset);
			this.nextResults[8].set('heatStartOrder',3);
			S3Assignments.push(this.nextResults[8]);
		}
		if(this.nextResults.length > 9)
		{
			this.nextResults[9].set('newBib',10+bibOffset);
			this.nextResults[9].set('heatStartOrder',4);
			S3Assignments.push(this.nextResults[9]);
		}
		if(this.nextResults.length > 14)
		{
			this.nextResults[14].set('newBib',15+bibOffset);
			this.nextResults[14].set('heatStartOrder',5);
			S3Assignments.push(this.nextResults[14]);
		}
		if(this.nextResults.length > 15)
		{
			this.nextResults[15].set('newBib',16+bibOffset);
			this.nextResults[15].set('heatStartOrder',6);
			S3Assignments.push(this.nextResults[15]);
		}
		
		this.S1Assignments = S1Assignments;
		this.S2Assignments = S2Assignments;
		this.S3Assignments = S3Assignments;
		
	}
	
	async updateResults()
	{

		//var classGroup = this.sourceClassGroup;

		if(this.sourceClassGroup == null)
		{
			this.top30Results = null;
			this.updateHeatAssignments();
			return;
		}

		var top30Results = [];
		var nextResults = [];

		await this.sprintTools.fetchResultsForEvent(this.sourceEvent.id);
		
		var results = await this.sourceClassGroup.get('resultsSorted');

		var count = 0;
		var countNext = 0;
		for (const result of results)
		{
			if(count >= this.resultsOffset && countNext < 18)
			{
				if(this.selectedClasses.includes(result.className))
				{
					countNext++;
					result.set('useResultForTie',false);
					nextResults.push(result);
				}
			}
			if(count < this.resultsOffset)
			{
				count++;
				result.set('useResultForTie',false);
				top30Results.push(result);
			}
		}
		
		// Sort by time, break ties by lowest SP points
		top30Results.sort((a, b) => this.sprintTools.sortByTimeWithTieBreaker(a, b));
		nextResults.sort((a, b) => this.sprintTools.sortByTimeWithTieBreaker(a, b));

		this.top30Results = top30Results;
		this.nextResults = nextResults;
		this.updateHeatAssignments();
		
	}
}
